module.exports = __webpack_public_path__ + "media/images/logo-ratepay-2372b864bf0cda2d02a6fea4aedbe5cc.svg";